"use client"
import { Box, Divider, FormControl, FormControlLabel, Radio } from '@mui/material';
import React from 'react';
import { getCurrencySign, storeAssigned } from '@/services/Methods/normalMethods';
import _ from 'lodash';

function ShippingSection(props) {

    const { section, shippingMethods, selectedCheck, _handleShippingChange } = props;
    const CURRENT_STORE = _.upperCase(storeAssigned()) || 'US';

    return (
        <div className='shipping_option_div max-w-[708px]'>
            <div className='mb-[25px] border-b border-[#000]'>
                <h3 className='mb-[4px] lg:text-[22px] sm:text-[18px] text-[16px] lg:text-left text-center' style={{ textTransform: "capitalize" }}>{section} Shipping Method</h3>
            </div>
            <div className='shipping_methodOptions xl:mb-[34px] mb-[24px] flex flex-col gap-[22px]'>
                {(shippingMethods?.length > 0) ? (
                    shippingMethods?.map((data, index) => {
                        const FormattedValue = Math.floor(parseFloat(data?.amount) * 100) / 100;
                        return (
                            data?.shipCarrierId !== 10 && <Box className="shiping_methods " key={data?.shipMethodType}>
                                <div className="radio_option">
                                    <label className='relative flex flex-wrap w-full'>
                                        <input
                                            // defaultValue={data?.amount}
                                            type='radio'
                                            checked={selectedCheck?.shipMethodType === data?.shipMethodType}
                                            onChange={() => _handleShippingChange(data, section)}
                                            name={`radio-button-demo_${_.lowerCase(section)}`}
                                            className='absolute opacity-0 pointer-events-none peer'
                                        />
                                        <span className={`
                                        cursor-pointer text-[15px] text-black w-full flex py-6 px-5 border-[2px] border-clr rounded-[6px] 
                                        transition-all ease-in-out duration-300 before:content-[""] before:w-[20px] before:h-[20px] 
                                        before:border-[2px] before:border-clr before:block before:mr-[12px] before:transition-all 
                                        before:ease-in-out before:duration-300 before:rounded-[100%] after:content-[""] 
                                        after:h-[6px] after:w-[6px] after:bg-white after:absolute after:top-[33px] after:left-[29px] 
                                        after:rounded-[100%] peer-checked:before:bg-[#000000] peer-checked:before:border-[#000000] 
                                        peer-checked:bg-[#f2f2f2]`}>
                                            {`${data?.shipMethodDescription}: ${getCurrencySign(CURRENT_STORE)}${FormattedValue.toFixed(2)}`}
                                        </span>
                                    </label>
                                </div>
                            </Box>
                        );
                    })
                ) : (
                    <p className='error'>No shipping method on this address.</p>
                )}
            </div>
        </div>
    )
}

export default ShippingSection;